import React from "react";
import Accordion from "../Accordion";
import { useQuery } from "react-query";
import { getProgramInfo } from "@website-builder/services";
import { Wrapper } from "./style";
const Tuition = ({
	headerName,
	headerAlignment,
	headerSize,
	subHeader,
	activeStateColor,
	inactiveStateColor,
	shortname,
	programName,
	getAccordionItems,
}) => {
	const { data = {} } = useQuery(
		["paymentPlanDetails", programName],
		getProgramInfo(shortname, programName),
	);
	const { content: { payment_plans = [] } = {} } = data;
	const shouldDisplayTuition =
		Array.isArray(payment_plans) && payment_plans.length;
	const accordionItems = getAccordionItems(payment_plans);

	return (
		<>
			{shouldDisplayTuition ? (
				<Wrapper>
					<Accordion
						headerName={headerName}
						accordionItems={accordionItems}
						headerAlignment={headerAlignment}
						headerSize={headerSize}
						subHeading={subHeader}
						activeStateColor={activeStateColor}
						inactiveStateColor={inactiveStateColor}
					/>
				</Wrapper>
			) : null}
		</>
	);
};

export default Tuition;
